module.exports = __webpack_public_path__ + "static/media/Chitra Sangle.6bc87954.jpg";